import { fetchUserWrapupStatusTime } from '@api/queries/fetchUserWrapupStatusTime';
import appManager from '@app/appManager';
import ServiceModule from '@modules/ServiceModule';
import ServiceUser from '@modules/ServiceModule/workspace/types/ServiceUser';
import { ServiceUserUtils } from '../serviceUserUtils';
import { getWrapupTimingData } from './wrapupUtils';

export const handleUserWrapUpStatusOnLoad = async ({
  user,
}: {
  user: ServiceUser;
}) => {
  try {
    // If user is not in wrap up state on load, no need to handle
    if (!user || !ServiceUserUtils.isWrapUp(user)) {
      return;
    }
    // User is in wrapup state, check if there is wrapup time data from API
    const apiData = await getUserWrapupTimeByAPI(user);
    if (apiData) {
      ServiceModule.putAgentInWrapupState(apiData);
      return;
    }
  } catch (err) {
    appManager
      .logger('Inbox')
      .error(
        'wrapup-onload: Failed to handle user wrap up status on load',
        err,
        ' user ',
        user,
      );
    throw err;
  }
};

export const getUserWrapupTimeByAPI = async (user: ServiceUser) => {
  try {
    if (!user.contactCenterUserId) {
      appManager
        .logger('Inbox')
        .error(
          'wrapup-onload: user has no contactCenterUserId',
          ' user ',
          user,
        );
      return;
    }
    const data = await fetchUserWrapupStatusTime({
      userId: user.contactCenterUserId,
    });
    if (
      data &&
      data.startedTimestamp &&
      data.elapsedTime &&
      data.remainingTime
    ) {
      const { wrapupAllowedMs, timestamp } = getWrapupTimingData(data);

      if (!wrapupAllowedMs || wrapupAllowedMs <= 0) {
        appManager
          .logger('Inbox')
          .error(
            'wrapup-onload: Invalid wrapup allowed time',
            wrapupAllowedMs,
            ' for user ',
            user,
          );
        return;
      }

      if (timestamp && wrapupAllowedMs) {
        const data = {
          user,
          agentId: user.id,
          available: ServiceUserUtils.isUserAvailable(user),
          wrapupAllowedMs,
          timestamp,
          conversationId: 'WRAPUP_RELOAD',
          conversationSid: 'WRAPUP_RELOAD',
        };
        appManager
          .logger('Inbox')
          .info('wrapup-onload:' + JSON.stringify(data, null, 2));
        return data;
      } else {
        appManager
          .logger('Inbox')
          .error('wrapup-onload: Conversation data not found');
      }
    } else {
      appManager
        .logger('Inbox')
        .error(
          'wrapup-onload: User in wrapup , but wrapup time data not found from API',
        );
    }
    return null;
  } catch (err) {
    appManager
      .logger('Inbox')
      .error(
        'wrapup-onload: Failed to fetch user wrap up status via API',
        err,
        ' user ',
        user,
      );
    throw err;
  }
};
